import React from 'react'
import t from 'prop-types'

import Icono from './iconos-go'

function onHitoActivo(){
    return
}

const HitoTipo1 = ({hito, onHito}) => {
    const [,tipo, texto] = hito.boton.split(',')
    const [colorBoliche, colorBoton, numIcono, textoIcono, textoSecundario] = hito.notasBD.split('#')
    const num = 100 * Number(tipo) + Number(numIcono)

    return (
        <div className={`hito${hito.activo ? ' activa': ''}`} onClick={ hito.activo ? onHitoActivo : onHito }>
            <div className={"tipoBoliche1 colorBoliche" + colorBoliche}></div>
            <div className={`tipoBotonHito${tipo} colorBotonHito${colorBoton} iconoBotonHito${num}`}>
                <Icono num={num} />
                { textoIcono && <div>{ textoIcono }</div>}
            </div>
            <span>{ texto }{ textoSecundario && <span className="textoSecundario">{ textoSecundario }</span> }</span>
        </div>
    )
}
HitoTipo1.propTypes = {
    hito: t.shape({
        boton: t.string,
        notasBD: t.string,
        activo: t.bool
    }),
    onHito: t.func
}

const HitoTipo2 = ({hito, onHito}) => {
    const [,tipo, texto] = hito.boton.split(',')
    const [, colorBoton, numIcono, , textoSecundario] = hito.notasBD.split('#')
    const num = 100 * Number(tipo) + Number(numIcono)
    return (
        <div className={`hito indentado1${hito.activo ? ' activa': ''}`} onClick={ hito.activo ? onHitoActivo : onHito }>
            <div className={`tipoBotonHito${tipo} colorBotonHito${colorBoton} iconoBotonHito${num}`}>
                <Icono num={num} />
            </div>
            <span>{ texto }{ textoSecundario && <span className="textoSecundario">{ textoSecundario }</span> }</span>
        </div>
    )
}
HitoTipo2.propTypes = {
    hito: t.shape({
        boton: t.string,
        notasBD: t.string,
        activo: t.bool
    }),
    onHito: t.func
}

const hitos = {
    "1": HitoTipo1,
    "2": HitoTipo2
}

const Hito = ({hito, onHito}) => {
    const [ , tipo, ] = hito.boton.split(',')
    const HitoTipo = hitos[tipo]
    return <HitoTipo hito={hito} onHito={onHito} />
}

Hito.propTypes = {
    hito: t.shape({
        boton: t.string,
        notasBD: t.string,
        activo: t.bool
    }),
    onHito: t.func
}

export default Hito